import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ImpersonateBanner = () => {
  const { t } = useTranslation();
  
  const impersonatedBy = localStorage.getItem('impersonated_by');
  
  if (!impersonatedBy) return null;
  
  const adminInfo = JSON.parse(impersonatedBy);
  
  const handleReturnToAdmin = () => {
    // Restore original admin session
    const originalToken = localStorage.getItem('admin_original_token');
    const originalUser = localStorage.getItem('admin_original_user');
    
    if (originalToken && originalUser) {
      localStorage.setItem('token', originalToken);
      localStorage.setItem('user', originalUser);
      localStorage.removeItem('admin_original_token');
      localStorage.removeItem('admin_original_user');
      localStorage.removeItem('impersonated_by');
      
      // Redirect to admin panel
      window.location.href = '/admin';
    }
  };
  
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-yellow-500 text-yellow-900 py-2 px-4 flex items-center justify-center gap-4 shadow-md">
      <AlertTriangle className="w-5 h-5" />
      <span className="font-medium">
        {t('admin.impersonateMode') || 'Yönetici olarak giriş yapıldı'} - {adminInfo.name} ({adminInfo.email})
      </span>
      <Button 
        variant="secondary" 
        size="sm" 
        onClick={handleReturnToAdmin}
        className="bg-yellow-600 hover:bg-yellow-700 text-white border-0"
      >
        <LogOut className="w-4 h-4 mr-1" />
        {t('admin.returnToAdmin') || 'Admin Paneline Dön'}
      </Button>
    </div>
  );
};

export default ImpersonateBanner;
